import {Directive, HostListener, output} from '@angular/core';

@Directive({
    selector: '[appDnd]'
})
export class DndDirective {

    fileDropped = output<any>();

    @HostListener('dragover', ['$event'])
    public onDragOver(evt: any): void {
        evt.preventDefault();
        evt.stopPropagation();
    }

    @HostListener('dragleave', ['$event'])
    public onDragLeave(evt: any): void {
        evt.preventDefault();
        evt.stopPropagation();
    }

    @HostListener('drop', ['$event'])
    public onDrop(evt: any): void {
        evt.preventDefault();
        evt.stopPropagation();

        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
}
